/**
 * Objectif d'un widget à cible (jauge, barre de progression).
 *
 * Contrat commun aux deux : sans cible strictement positive, il n'y a rien à
 * afficher — pas de division, pas de valeur par défaut inventée. Une cible de repli
 * à 100 n'a aucun sens sur une métrique en euros ou sur un ratio en base 1 : les deux
 * widgets affichent « À configurer ».
 */

/** Cible déclarée, seulement si elle est finie et strictement positive. */
export function resolveTarget(raw: unknown): number | null {
  if (raw === undefined || raw === null || raw === '') return null;
  const target = Number(raw);
  if (!Number.isFinite(target) || target <= 0) return null;
  return target;
}
